<div class="login-page">

  <div class="card">

    <!-- Brand -->
    <div class="title"><img src="assets/logo2.png" alt="KreddyPay Logo" class="brand-logo" width="250" height="auto" />
    </div>

    <h2 class="title">Welcome to KreddyPay</h2>
    <!-- <p class="subtitle">Sign in to access your dashboard</p> -->

    <!-- Email -->
    <div class="form-group">
      <input type="email" [(ngModel)]="email" required placeholder=" " />
      <label>Email</label>
    </div>

    <!-- Password -->
    <div class="form-group password-group">
      <input [type]="passwordVisible ? 'text' : 'password'" [(ngModel)]="password" required placeholder=" " />
      <label>Password</label>

      <span class="eye" (click)="togglePassword()">
        <i [class]="passwordVisible ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
      </span>
    </div>

    <!-- Button -->
    <button class="btn primary" (click)="signIn()" [disabled]="!email || !password">
      Sign In
    </button>

  </div>

</div>